import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MaterialGrid from '@material-ui/core/Grid';
import LoadingProgress from 'common/components/progress/loading';
import _ from 'lodash';
import AlertDialogSlide from 'common/components/dialog/dialogActivits';
import ActionsTabs from 'common/components/navigation/actionsTab/activityTabs';
import Prize from 'modules/owner/pages/actions/sections/prize';
import Informations from 'modules/owner/pages/actions/sections/information';
import Interaction from 'modules/owner/pages/actions/research/sections/interaction';
import Publish from 'modules/owner/pages/actions/sections/publish';
import Modalities from 'modules/owner/pages/actions/copaSarau/sections/modalities';
import RoomRules from 'modules/owner/pages/actions/copaSarau/sections/roomRules';
import { imgToBase64, imgToImgType } from 'helpers/utils';
import { isMobile } from 'react-device-detect';
import { publishAction } from 'modules/owner/pages/actions/activeActions/activeActionsScripts';
import { getFormValues } from 'redux-form';
import { getList as getLottiesList } from '../../lotties/lottiesActions';
import { buildCopaSarauStationConfig, normalizeCopaSarauScheduleFields } from './config';
import {
  submitAction,
  getDetail,
  dispatchFormReset,
  savePartialy,
  initializeFormQuestions,
  initializeFormCopaSarauDefaults,
} from './copaSarauActions';

const sumIntegers = (values = []) =>
  values.reduce((acc, value) => acc + (parseInt(value, 10) || 0), 0);

const maxIntegers = (values = []) =>
  values.reduce((acc, value) => Math.max(acc, parseInt(value, 10) || 0), 0);

const computeActionAggregateFields = (stationSpecificData) => {
  const config = stationSpecificData.copa_sarau_config || {};
  const hotels = Array.isArray(config.hotels) ? config.hotels : [];
  const firstHotelRules = hotels[0]?.room_rules || config.room_rules || {};

  return {
    room_limit: parseInt(firstHotelRules.room_people_limit, 10) || 3,
    total_rooms_available: sumIntegers(
      hotels.map((hotel) => hotel.room_rules?.total_rooms_available)
    ),
    max_rooms_per_registration: maxIntegers(
      hotels.map((hotel) => hotel.room_rules?.max_rooms_per_registration)
    ),
    pending_reservation_ttl_hours:
      parseInt(config.pending_reservation_ttl_hours, 10) ||
      parseInt(config.room_rules?.pending_reservation_ttl_hours, 10) ||
      24,
  };
};

function Main(props) {
  const [value, setValue] = React.useState(0);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    props.getLottiesList();
  }, []);

  async function handleChange(values, router) {
    const normalizedValues = normalizeCopaSarauScheduleFields({ ...values });

    normalizedValues.base64 = normalizedValues.image.base64;
    if (!_.isUndefined(normalizedValues.image.base64)) {
      normalizedValues.imageType = imgToImgType(normalizedValues.image);
    }

    const stationSpecificData = buildCopaSarauStationConfig(normalizedValues);
    const aggregateActionFields = computeActionAggregateFields(stationSpecificData);

    normalizedValues.body = {
      ...normalizedValues,
      name: normalizedValues.body_name,
      description: normalizedValues.body_description,
    };
    normalizedValues.station_specific_data = stationSpecificData;
    normalizedValues.companion_price = stationSpecificData.body_valor_acompanhante;
    normalizedValues.extra_room_price = stationSpecificData.body_valor_quarto_extra;
    normalizedValues.room_limit = aggregateActionFields.room_limit;
    normalizedValues.total_rooms_available = aggregateActionFields.total_rooms_available;
    normalizedValues.max_rooms_per_registration = aggregateActionFields.max_rooms_per_registration;
    normalizedValues.pending_reservation_ttl_hours =
      aggregateActionFields.pending_reservation_ttl_hours;

    normalizedValues.type_action = normalizedValues.type.id;
    delete normalizedValues.body.image;
    delete normalizedValues.body.base64;
    delete normalizedValues.body.imageType;
    normalizedValues.body = JSON.stringify(normalizedValues.body);

    const selectedVideos = [];
    selectedVideos.push({
      video_id: normalizedValues.videoIdField,
      name: '',
      description: '',
      required: false,
    });
    normalizedValues.videos = [...selectedVideos];

    props.savePartialy(normalizedValues, router, setValue, value);
  }

  function goBack() {
    setValue(value - 1);
  }

  function handleOpenConfirmation() {
    setOpenConfirmation(true);
  }

  function handleCancelClose() {
    setOpenConfirmation(false);
  }

  function handleNativeChange(e, newValue) {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      setValue(newValue);
    } else {
      if (newValue < value) {
        setValue(newValue);
      }
    }
  }

  useEffect(() => {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      props.getDetail(props.router.params.id);
    }
  }, []);

  const copaSarauDefaultQuestions = [
    { question: { text: 'Nome Completo' }, type: 3, options: [] },
    { question: { text: 'CPF' }, type: 3, options: [] },
    { question: { text: 'E-mail' }, type: 3, options: [] },
    { question: { text: 'Telefone celular' }, type: 3, options: [] },
    { question: { text: 'Data de nascimento' }, type: 3, options: [] },
    { question: { text: 'Cidade' }, type: 3, options: [] },
    {
      question: { text: 'Estado/UF' },
      type: 1,
      options: [
        { label: { text: 'AC' } },
        { label: { text: 'AL' } },
        { label: { text: 'AP' } },
        { label: { text: 'AM' } },
        { label: { text: 'BA' } },
        { label: { text: 'CE' } },
        { label: { text: 'DF' } },
        { label: { text: 'ES' } },
        { label: { text: 'GO' } },
        { label: { text: 'MA' } },
        { label: { text: 'MT' } },
        { label: { text: 'MS' } },
        { label: { text: 'MG' } },
        { label: { text: 'PA' } },
        { label: { text: 'PB' } },
        { label: { text: 'PR' } },
        { label: { text: 'PE' } },
        { label: { text: 'PI' } },
        { label: { text: 'RJ' } },
        { label: { text: 'RN' } },
        { label: { text: 'RS' } },
        { label: { text: 'RO' } },
        { label: { text: 'RR' } },
        { label: { text: 'SC' } },
        { label: { text: 'SP' } },
        { label: { text: 'SE' } },
        { label: { text: 'TO' } },
      ],
    },
    {
      question: { text: 'Situação funcional' },
      type: 1,
      options: [
        { label: { text: 'Ativo' } },
        { label: { text: 'Aposentado' } },
        { label: { text: 'Pensionista' } },
      ],
    },
    { question: { text: 'Matrícula' }, type: 3, options: [] },
    {
      question: { text: 'Órgão de lotação' },
      type: 1,
      options: [
        { label: { text: 'Câmara' } },
        { label: { text: 'Senado' } },
        { label: { text: 'TCU' } },
      ],
    },
  ];

  // Pré-carregar perguntas fixas e modalidades padrão ao criar nova atividade
  useEffect(() => {
    const isNewActivity =
      props.router.params.action !== 'editar' &&
      props.router.params.action !== 'proposta' &&
      props.router.params.action !== 'rascunho';
    if (isNewActivity) {
      props.initializeFormCopaSarauDefaults(copaSarauDefaultQuestions);
    }
  }, []);

  // Pré-carregar perguntas fixas ao editar atividade sem perguntas
  useEffect(() => {
    if (props.contactsSurveys.status === 'resolved') {
      const hasQuestions = props.formValues?.questions && props.formValues.questions.length > 0;
      if (!hasQuestions) {
        props.initializeFormQuestions(copaSarauDefaultQuestions);
      }
    }
  }, [props.contactsSurveys.status]);

  const onSubmit = async (values) => {
    const { auth } = props;
    const normalizedValues = normalizeCopaSarauScheduleFields({ ...values });

    if (!_.isUndefined(normalizedValues.image.base64)) {
      normalizedValues.imageType = imgToImgType(normalizedValues.image);
      normalizedValues.base64 = imgToBase64(normalizedValues.image);
    }

    const stationSpecificData = buildCopaSarauStationConfig(normalizedValues);
    const aggregateActionFields = computeActionAggregateFields(stationSpecificData);

    const newValues = {
      ...normalizedValues,
      partner: normalizedValues.partner_id,
      limit: parseInt(normalizedValues.limit),
      points: normalizedValues.points,
      name: normalizedValues.name,
      description: normalizedValues.description,
      station_specific_data: stationSpecificData,
      companion_price: stationSpecificData.body_valor_acompanhante,
      extra_room_price: stationSpecificData.body_valor_quarto_extra,
      room_limit: aggregateActionFields.room_limit,
      total_rooms_available: aggregateActionFields.total_rooms_available,
      max_rooms_per_registration: aggregateActionFields.max_rooms_per_registration,
      pending_reservation_ttl_hours: aggregateActionFields.pending_reservation_ttl_hours,
      establishment: auth.user.establishments[0].id,
      station: auth.user.establishments[0].stations[0].id,
      type_action: normalizedValues.type.id,
    };

    const target =
      normalizedValues.segmentation_type === 'public'
        ? {
            age: {
              from: normalizedValues.from,
              to: normalizedValues.to,
            },
            states: normalizedValues.states,
            associated: normalizedValues.associated,
            internal: normalizedValues.internal,
            plans: normalizedValues.segment_plans,
            entities: normalizedValues.entities,
          }
        : {
            segment_users: normalizedValues.segment_users,
          };

    newValues.target = target;

    const create_or_update =
      props.router.params.action === 'editar' ||
      props.router.params.action === 'rascunho' ||
      props.router.params.action === 'proposta'
        ? 'update'
        : 'create';
    const id_action = props.router.params.id;

    let publish = null;
    if (props.router.params.action === 'rascunho') {
      publish = () => {
        return props.publishAction(
          props.router.params.id,
          props.router,
          'contactsSurveysForm',
          'CONTACTS_SURVEY_BUTTON_LOAD'
        );
      };
    }

    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      newValues.research_id = props.contactsSurveys?.detail?.researches?.[0]?.id;
    }

    props.submitAction(newValues, props.router, create_or_update, id_action, publish);
  };

  function onDialogClose() {
    props.dispatchFormReset();

    const from = props.location.query.from ? props.location.query.from : 'online';

    props.router.push(
      props.router.params.action === 'editar'
        ? `/owner/acoes/minhas-atividades?from=${from}`
        : props.router.params.action === 'rascunho'
        ? '/owner/acoes/minhas-atividades?from=drafts'
        : props.router.params.action === 'proposta'
        ? '/owner/acoes/propostas'
        : '/owner'
    );
  }

  return (
    <AlertDialogSlide
      label={'Inscrição Copa/Sarau'}
      value={value}
      test={true}
      visible={true}
      height="95vh"
      form={props.formValues}
      onClose={handleOpenConfirmation}
      maxWidth={isMobile ? 'xl' : 'sm'}>
      {props.contactsSurveys.status === 'pending' || props.contactsSurveys.status === 'idle' ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingProgress />
        </div>
      ) : (
        <MaterialGrid container direction="column" justifyContent="center" alignItems="stretch">
          <ActionsTabs
            styles={{ marginBottom: 35, width: '100%' }}
            icons={[0, 2, 0, 1, 0, 0]}
            sectionTitles={[0, 2, 0, 0, 0, 0]}
            handleChange={handleNativeChange}
            onClickProgress={(values) => {
              if (values.submitFromButton) {
                return;
              }
              handleChange(values, props.router);
            }}
            goBack={goBack}
            form="contactsSurveysForm"
            activeTab={value}
            tabs={[
              {
                content: (
                  <Informations
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    template={props.location.query.template}
                    type={props.location.query.type}
                    router={props.router}
                    form="contactsSurveysForm"
                    onClickProgress={(values) => handleChange(values, props.router)}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                icon: 'subject',
                label: 'Apresentação',
              },
              {
                content: (
                  <Interaction
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    router={props.router}
                  />
                ),
                icon: 'forum',
                label: 'Interação',
              },
              {
                content: (
                  <Modalities
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    router={props.router}
                  />
                ),
                icon: 'product',
                label: 'Modalidades',
              },
              {
                content: (
                  <RoomRules
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    router={props.router}
                  />
                ),
                icon: 'ticket',
                label: 'Valores e regras dos quartos',
              },
              {
                content: (
                  <Prize
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    router={props.router}
                    disabled={props.router.params.action === 'editar'}
                    form="contactsSurveysForm"
                    hideTrophy
                    hideGiveaway
                  />
                ),
                label: 'Feedback',
                icon: 'loyalty',
              },
              {
                content: (
                  <Publish
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => onSubmit(values)}
                    form="contactsSurveysForm"
                    prevClick={goBack}
                    disabled={props.router.params.action === 'editar'}
                    router={props.router}
                    nativePicker
                  />
                ),
                label: 'Publicação',
                icon: 'settings',
              },
            ]}></ActionsTabs>
        </MaterialGrid>
      )}
    </AlertDialogSlide>
  );
}

Main.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  contactsSurveys: PropTypes.shape({
    detail: PropTypes.shape({
      researches: PropTypes.any,
    }),
    status: PropTypes.string,
  }),
  dispatchFormReset: PropTypes.func,
  formValues: PropTypes.any,
  getDetail: PropTypes.func,
  getLottiesList: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      from: PropTypes.any,
      template: PropTypes.any,
      type: PropTypes.any,
    }),
  }),
  publishAction: PropTypes.func,
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
      id: PropTypes.any,
    }),
    push: PropTypes.func,
  }),
  savePartialy: PropTypes.func,
  submitAction: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    contactsSurveys: state.contactsSurveys,
    formValues: getFormValues('contactsSurveysForm')(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      submitAction,
      getDetail,
      dispatchFormReset,
      getLottiesList,
      savePartialy,
      publishAction,
      initializeFormQuestions,
      initializeFormCopaSarauDefaults,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
